import React from 'react';
import TitlePaymentLink from '../../components/title-payment-link';
import Hr from '../../components/Style/hr';
import { useTranslation } from 'react-i18next';

export default function StepRecapProduct({ paymentLinkData, returnedData }) {
    const { t } = useTranslation();

    const totalPrice = (paymentLinkData?.products || []).reduce(
        (acc, p) => acc + (p.priceTTC || 0) * (p.quantity || 1),
        0
    );

    const handleNextStep = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        returnedData({ step: "step2" });
    };

    return (
        <>
            <TitlePaymentLink
                title={t('pagePaymentLink.step1.welcomeMessage')}
                description={t('pagePaymentLink.step1.description')}
                step="1"
            />
            <Hr />
            <div className="first-step-container">
                <div className="text-base font-bold mb-4 text-main">
                    {t('pagePaymentLink.step1.orderRecap')}
                </div>

                {/* TABLEAU VERSION DESKTOP */}
                <table className="table-payment-link hidden md:table w-full border-collapse">
                    <thead>
                        <tr>
                            <th className="text-left py-3 text-primary font-normal text-sm w-[55%]">
                                {t('pagePaymentLink.step1.productInfo')}
                            </th>
                            <th className="text-center py-3 text-primary font-normal text-sm w-[15%]">
                                {t('pagePaymentLink.step1.quantity')}
                            </th>
                            <th className="text-center py-3 text-primary font-normal text-sm w-[15%]">
                                {t('pagePaymentLink.step1.tax')}
                            </th>
                            <th className="text-right py-3 text-primary font-normal text-sm w-[15%]">
                                {t('pagePaymentLink.step1.totalPrice')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(paymentLinkData?.products || []).map((product, i) => (
                            <tr key={i} className="border-b border-[#eeeff3]">
                                <td className="py-5 w-[55%]">
                                    <div className="flex items-start flex-col gap-4">
                                        <p className="font-medium text-primary mb-0">{product.label}</p>
                                        {product.description && (
                                            <p className="text-xs font-light">{product.description}</p>
                                        )}
                                    </div>
                                </td>
                                <td className="text-center w-[15%]">{product.quantity}</td>
                                <td className="text-center w-[15%]">{product.tax}%</td>
                                <td className="text-right w-[15%]">
                                    <div className="flex flex-col items-end">
                                        <span>{(product.priceTTC * product.quantity).toFixed(2)} €</span>
                                        {product.publicPrice && (
                                            <span className="line-through text-sm font-light">
                                                {(product.publicPrice * product.quantity).toFixed(2)} €
                                            </span>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan="4">
                                <div className="h-6" />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td className="text-right font-semibold text-lg text-primary">
                                {t('pagePaymentLink.step1.totalTTC')}
                            </td>
                            <td className="text-right font-semibold text-lg text-primary">
                                {totalPrice.toFixed(2)} €
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* VERSION MOBILE */}
                <div className="block md:hidden mt-4">
                    <span className="text-sm font-medium text-primary block mb-3">
                        {t('pagePaymentLink.step1.productInfo')}
                    </span>
                    {(paymentLinkData?.products || []).map((product, i) => (
                        <div key={i} className="border-t border-[#eeeff3] mb-6 pt-4">
                            <div className="flex gap-4">
                                {product.img && (
                                    <div className="w-[60px] h-[60px] rounded-lg overflow-hidden">
                                        <img src={product.img} alt={product.label} className="w-full h-full object-cover" />
                                    </div>
                                )}
                                <div>
                                    <p className="pp-product-title text-primary text-base font-medium">{product.label}</p>
                                    {product.description && (
                                        <p className="text-xs font-light text-primary">{product.description}</p>
                                    )}
                                    {product.attachment && (
                                        <div className="mt-2">
                                            <a href={product.attachment} download className="btn text-sm">
                                                {t('pagePaymentLink.step1.downloadAttachment')}
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="mt-4 flex justify-between">
                                <div className="text-center">
                                    <span className="block text-xs text-primary">{t('pagePaymentLink.step1.quantity')}</span>
                                    <span className="text-sm text-primary">{product.quantity}</span>
                                </div>
                                <div className="text-center">
                                    <span className="block text-xs text-primary">{t('pagePaymentLink.step1.tax')}</span>
                                    <span className="text-sm text-primary">{product.tax}%</span>
                                </div>
                                <div className="text-center">
                                    <span className="block text-xs text-primary">{t('pagePaymentLink.step1.totalPrice')}</span>
                                    <span className="text-sm text-primary">{(product.priceTTC * product.quantity).toFixed(2)} €</span>
                                    {product.publicPrice && (
                                        <span className="block text-xs line-through text-primary">
                                            {(product.publicPrice * product.quantity).toFixed(2)} €
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="text-right font-semibold text-lg text-primary mt-6">
                        {t('pagePaymentLink.step1.totalTTC')} &nbsp;&nbsp; {totalPrice.toFixed(2)} €
                    </div>
                </div>

                <div className="first-step-actions mt-12 text-right">
                    <button
                        className="px-6 py-2 rounded-md bg-main text-white hover:bg-primary"
                        onClick={handleNextStep}
                    >
                        {t('services.nextStep')}
                    </button>
                </div>
            </div>
        </>
    );
}